import AddressNotFoundError from '../domain/error/AddressNotFoundError'
import PageNotFoundError from '../domain/error/PageNotFoundError'
import PermanentRedirectError from '../domain/error/PermanentRedirectError'
import ServerError from '../domain/error/ServerError'

export const getTechnicalError = err => {
  if (__BROWSER__) return err
  if (err instanceof AddressNotFoundError) return new PageNotFoundError(err)
  if (err instanceof PermanentRedirectError) return err
  if (err instanceof ServerError) return err
  return new ServerError(err)
}

export const technicalErrorCatcher = err => Promise.reject(getTechnicalError(err))
